export const searchFilterType = {
    all: 1,
    tours: 2,
    news: 3,
};
